// extracted by mini-css-extract-plugin
export default {"container":"aVHDY","skeleton-placeholder-pulse":"iF6g0","skeletonPlaceholderPulse":"iF6g0"};